import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, isEqual } from 'lodash';
import { setActiveModalAction } from '../../../../actions';
import { Icon, IconTypes } from '../../../../components';
import { fromStore } from '../../../../selectors';
import { getAdress } from '../../../../utils';
import { DeliveryZone } from './DeliveryZone';

export function Adress() {
  const dispatch = useDispatch();
  const user = useSelector(fromStore.userSelector);
  const adress = useSelector(fromStore.orderDeliveryAdressSelector);
  const city = useSelector(fromStore.selectedCitySelector);
  const onAdressModal = () => {
    dispatch(setActiveModalAction({ field: 'adress', value: true }));
  };

  const onAdressesModal = () => {
    dispatch(setActiveModalAction({ field: 'addresses', value: true }));
  };

  const getFilteredAddresses = () => {
    if (isEmpty(user) || isEmpty(user.addresses) || isEmpty(city)) return null;

    let result = user.addresses;
    if (adress.street) {
      result = result.filter((address) => {
        const dataAddress = {
          street: address.street || null,
          house: address.house || null,
          room: address.room || null,
          entrance: address.entrance || null,
          privateHouse: address.privateHouse || false,
          area: address.area || null,
          floor: address.floor || null,
        };
        const dataOrder = {
          street: adress.street || null,
          house: adress.house || null,
          room: adress.room || null,
          entrance: adress.entrance || null,
          privateHouse: adress.privateHouse || false,
          area: adress.area || null,
          floor: adress.floor || null,
        };
        return !isEqual(dataAddress, dataOrder);
      });
    }

    result = result.filter((address) => address.cityId === city.id);
    return result;
  };

  const filteredAddresses = getFilteredAddresses();

  return (
    <div>
      <h3 className="required">Адрес доставки</h3>
      {adress.street ? (
        <>
          {filteredAddresses && <button onClick={onAdressesModal} type="button" className="btn btn-primary btn-sm my-5 py-2 btn-hover-rise">Выбрать другой адрес доставки</button>}
          <div className="col-lg-12 d-flex align-items-center border border-secondary rounded ps-5 pe-1 py-1 flex-stack">
            <span className="fw-bolder fs-5 text-gray-800">{getAdress(adress, city.name)}</span>
            <button onClick={onAdressModal} type="button" className="btn btn-sm btn-icon btn-light btn-active-white ms-1 btn-hover-scale">
              <Icon type={IconTypes.edit} className="svg-icon svg-icon-3" />
            </button>
          </div>
        </>
      ) : (
        <div className="mt-5 col-lg-12 d-flex align-items-center gap-5">
          <button onClick={onAdressModal} type="button" className="btn btn-danger btn-sm py-2 btn-hover-rise">Добавить адрес доставки</button>
          {filteredAddresses && <button onClick={onAdressesModal} type="button" className="btn btn-primary btn-sm py-2 btn-hover-rise">Выбрать адрес доставки</button>}
        </div>
      )}
      {adress.street && <DeliveryZone />}
    </div>
  );
}
